import { render } from "./InternalGraphPopup.vue?vue&type=template&id=56fed0fd&scoped=true"
import script from "./InternalGraphPopup.vue?vue&type=script&lang=js"
export * from "./InternalGraphPopup.vue?vue&type=script&lang=js"

import "./InternalGraphPopup.vue?vue&type=style&index=0&id=56fed0fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fed0fd"]])

export default __exports__